
import { Component, Vue } from "vue-property-decorator";
import vBreadcrumbs from "@/components/vBreadcrumbs.vue";
import vModal from "@/components/vModal.vue";
import { mapState } from "vuex";
import { TRANSLATIONS_FETCH } from "@/store/ActionTypes";
import ListRequest from "@/models/ListRequest";
import { getErrorMessage, mapNutritions } from "@/utils/Helpers";
import { IngredientCost } from "@/models/IngredientCost/IngredientCost";
import { Recipe } from "@/models/Recipes/Recipe";
import RecipeCostRepository from "@/utils/API/RecipeCostRepository";
import { MeasurementCategory } from "@/models/Measurement/MeasurementCategory";
import IngredientCostRepository from "@/utils/API/IngredientCostRepository";
import MeasurementRepository from "../../utils/API/MeasurementRepository";
import RecipesRepository from "@/utils/API/RecipesRepository";
import vAutocomplete from "@/components/vAutocomplete.vue";
import {RecipeCostRecipeDetails} from "@/models/RecipeCost/RecipeCostRecipeDetails";

const vSelect2 = () => import("@/components/vSelect2.vue");

type AddMeasurementModalModel = {
  ingredientCostId: number | null;
  isOpen: boolean;
  newMeasurements: any[];
  ingrCostIndex: number;
};

@Component({
  components: {
    vBreadcrumbs,
    vModal,
    vSelect2,
    vAutocomplete,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    }),
  },
})
class RecipeCostComponent extends Vue {
  localizationState: any;

  recipe: Recipe = new Recipe();
  recipeIngredientCosts: any[] = [];
  subRecipeCosts: any[] = [];

  ingredientCosts: IngredientCost[] = [];
  ingredientCost: any = {};
  allIngredientCosts: any[] = [];
  newIngredientCost: any;
  massMeasurements: any[] = [];
  vendors: any[] = [];
  addingVendorName: string = "";

  addingIngredientCostModal = {
    isOpen: false,
  };

  addingVendorModal = {
    isOpen: false,
  };

  addingMeasurementModal: AddMeasurementModalModel = {
    ingredientCostId: null,
    isOpen: false,
    newMeasurements: [],
    ingrCostIndex: -1,
  };

  itemSelected(ingredientCost: any, recipeIngredientCost: any) {
    if (recipeIngredientCost.ingredientCostId) {
      ingredientCost = this.allIngredientCosts.find(
        (x) => x.id == recipeIngredientCost.ingredientCostId
      );
      if (ingredientCost) {
        recipeIngredientCost.ingredientCostName = ingredientCost.name;
        recipeIngredientCost.costPerGram = ingredientCost.costPerGram;
      }
      else {
        recipeIngredientCost.ingredientCostName = "";
        recipeIngredientCost.costPerGram = 0;
      }
    }
  }

  // Calculate cost for recipe ingredient cost
  calculateCostForRecipeIngredientCost(
    quantity: number,
    measurementWeightInGram: number,
    ingrCostPerGram: number
  ) {
    return quantity * measurementWeightInGram * ingrCostPerGram;
  }

  vendorForRecipeIngredientCostChanged(recIngrCost: any) {
    let ingredientCostsForVendor = this.getIngredientCostsForVendor(
      recIngrCost.ingredientCostVendorId
    );
    recIngrCost.ingredientCostId = null;
    recIngrCost.costPerGram = 0;
  }

  formatNumber(number: number) {
    return (Math.round(number * 100) / 100).toFixed(2);
  }

  // Save ingredient cost button modal
  saveIngredientCost() {
    this.$validator.validateAll("ingredientCost").then((result) => {
      if (result) {
        // @ts-ignore
        this.$snotify.async(
          this.translations.get("ingr-cost-loading"),
          () =>
            new Promise((success, reject) => {
              IngredientCostRepository.createIngredientCosts([
                this.ingredientCost,
              ])
                .then(() => {
                  this.addingIngredientCostModal.isOpen = false;
                  this.loadAllIngredientCosts();
                  success({
                    body: this.translations.get("ms_save_success"),
                  });
                })
                .catch((error) => {
                  reject({
                    body: getErrorMessage(error, this.translations),
                  });
                });
            }),
          { closeOnClick: true, timeout: 3500 }
        );
      }
    });
  }

  // Remove measurement row
  removeMeasurementRow(index: any) {
    this.addingMeasurementModal.newMeasurements.splice(index, 1);
    setTimeout(() => {
      this.$validator.validateAll("measurement");
    }, 300);
  }

  // Open Add ingredient cost modal
  openAddIngredientCostModal() {
    this.ingredientCost = this.getEmptyIngredientCost();
    this.addingIngredientCostModal.isOpen = true;
  }

  loadAllIngredientCosts() {
    let reqData = new ListRequest({
      page: 1,
      pageSize: 9999,
      filters: [],
      orders: [],
    });
    IngredientCostRepository.listIngredientCost(reqData).then(
      (res) => {
        this.allIngredientCosts = res.data.result;
      },
      () => {}
    );
  }

  // Open Add measurement modal
  openAddMeasurementModal() {
    this.addingMeasurementModal.newMeasurements.length = 0;
    this.addingMeasurementModal.isOpen = true;
    // @ts-ignore
    this.$snotify.async(
      this.translations.get("ingr-cost-loading"),
      () =>
        new Promise((success, reject) => {
          IngredientCostRepository.loadMeasurementsForIngredientCost({
            id: null,
            name: this.ingredientCost.name,
            measurements: this.ingredientCost.ingredientCostMeasurements,
          })
            .then((response) => {
              if (response.data.result && response.data.result.length > 0) {
                this.addingMeasurementModal.newMeasurements.shift();
              }
              // @ts-ignore
              response.data.result.map((x) => {
                this.addingMeasurementModal.newMeasurements.push({
                  // @ts-ignore
                  name: x.name,
                  // @ts-ignore
                  weight: (Math.round(x.weightInGrams * 100) / 100).toFixed(2),
                });
              });
              success({
                body: this.translations.get("ms_save_success"),
              });
            })
            .catch((error) => {
              reject({
                body: getErrorMessage(error, this.translations),
              });
            });
        }),
      {
        timeout: 1000,
        closeOnClick: true,
      }
    );

    // @ts-ignore
    this.addingMeasurementModal.newMeasurements.push(this.getEmptyMeasurment());
  }

  // Open Add vendor modal
  openAddVendorModal() {
    this.addingVendorModal.isOpen = true;
  }

  // Add new measurement
  addNewMeasurement() {
    this.$validator.validateAll("measurement").then((result) => {
      if (result) {
        // @ts-ignore
        let ingrCost = this.ingredientCost;
        //  @ts-ignore
        let measurementNames = ingrCost.ingredientCostMeasurements.map(
          //  @ts-ignore
          (x) => x.name
        );
        this.addingMeasurementModal.newMeasurements.map((x) => {
          //  @ts-ignore
          if (!measurementNames.includes(x.name)) {
            ingrCost.ingredientCostMeasurements.push({
              //  @ts-ignore
              name: x.name,
              //  @ts-ignore
              weightInGrams: x.weight,
            });
          }
          return x;
        });
        this.addingMeasurementModal.isOpen = false;
      }
    });
  }

  // Add new vendor
  saveIngredientCostVendor() {
    this.$validator.validateAll("vendor").then((result) => {
      if (result) {
        // @ts-ignore
        this.$snotify.async(
          this.translations.get("ingr-cost-loading"),
          () =>
            new Promise((success, reject) => {
              IngredientCostRepository.createIngredientCostVendor(
                this.addingVendorName
              )
                .then(() => {
                  this.addingVendorModal.isOpen = false;
                  this.loadIngredientCostVendors();
                  this.addingVendorName = "";
                  success({
                    body: this.translations.get("ingr-cost-vendor-success"),
                  });
                })
                .catch((error) => {
                  reject({
                    body: getErrorMessage(error, this.translations),
                  });
                });
            }),
          {
            timeout: 3500,
            closeOnClick: true,
          }
        );
      }
    });
  }

  // Add new row in new ingredien costs modal
  addNewMeasurementRow() {
    // @ts-ignore
    this.addingMeasurementModal.newMeasurements.push(this.getEmptyMeasurment());
  }

  // Load list of ingredient cost Vendors
  loadIngredientCostVendors() {
    IngredientCostRepository.listIngredientCostVendors()
      .then((response) => {
        let vendors = response.data.result.map((x: any) => {
          return {
            id: x.id,
            name: x.name,
          };
        });
        this.vendors = vendors;
      })
      .catch((error) => {
        this.$snotify.error(getErrorMessage(error, this.translations));
      });
  }

  allIngredinsValid() {
    let valid = true;
    for (let i = 0; i < this.recipeIngredientCosts.length; i++) {
      if (this.recipeIngredientCosts[i].ingredientCostId == null) {
        valid = false;
      }
    }
    return valid;
  }

  // Save recipe cost button
  saveRecipeCost() {
    if (!this.allIngredinsValid()) {
      this.$snotify.error(
        this.translations.get("rec-cost-valid-recipe-ingr-costs")
      );
      return;
    }

    // @ts-ignore
    this.$snotify.async(
      this.translations.get("ingr-cost-loading"),
      () =>
        new Promise((success, reject) => {
          let recipeIngrCosts = this.recipeIngredientCosts.map((x) => {
            return {
              ingredientCostId: x.ingredientCostId,
              recipeIngredientId: x.recipeIngredientId,
            };
          });
          RecipeCostRepository.createRecipeCost({
            // @ts-ignore
            recipeId: this.recipe.id,
            recipeIngredientCosts: recipeIngrCosts,
          })
            // @ts-ignore
            .then((response) => {
              this.$router.push({
                name: "updateRecipeCost",
                params: { id: response.data.result },
              });
              success({
                body: this.translations.get("rec-cost-save-success"),
              });
            })
            // @ts-ignore
            .catch((error) => {
              reject({
                body: getErrorMessage(error, this.translations),
              });
            });
        }),
      { closeOnClick: true, timeout: 3500 }
    );
  }

  // Empty ingredient cost json
  getEmptyRecipeCost() {
    return {
      name: "",
      cost: 0,
      date: "",
      notification: "",
    };
  }

  // Empty measurement json
  getEmptyMeasurment(): { name: string; weight: number } {
    return {
      name: "",
      weight: null,
    };
  }

  // Empty ingredient cost json
  getEmptyIngredientCost() {
    return {
      name: "",
      vendorId: this.vendors.length > 0 ? this.vendors[0].id : null,
      quantity: 0,
      chosenMeasurementName:
        this.massMeasurements.length > 0 ? this.massMeasurements[0].name : null,
      ingredientCostMeasurements: [...this.massMeasurements],
      cost: 0,
    };
  }

  // Get Recipe details
  getRecipeDetails() {
    RecipesRepository.getRecipeDetails(parseInt(this.$route.params.id))
      .then((response) => {
        this.recipe = response.data;
        this.recipe.nutritionAnalysis = mapNutritions(
          this.recipe.nutritionAnalysis
        );
        this.recipeIngredientCosts = this.recipe.ingredients.map((x) => {
          // Select the vendor for the recipe ingredient cost
          let ingredientCostVendorId = this.vendors.length > 0 ? this.vendors[0].id : null;

          const rv: RecipeCostRecipeDetails = {
            recipeIngredientId: x.id,
            ingredientCostId: null,
            ingredientCostName: "",
            ingredientCostVendorId: ingredientCostVendorId,
            costPerGram: 0,
            ingredient: x.ingredient,
            measurement: x.measurement,
            quantity: x.quantity,
          };

          return rv;
        });

        this.listRecipeCostsForSubrecipes();
      })
      .catch((error) => {
        this.$snotify.error(getErrorMessage(error, this.translations));
      });
  }

  // Get Recipe costs for subrecipes
  listRecipeCostsForSubrecipes() {
    RecipeCostRepository.listRecipeCostsForSubrecipes(
      parseInt(this.$route.params.id)
    )
      .then((response) => {
        if (response.data.result.length > 0) {
          this.subRecipeCosts = response.data.result.map((x) => {
            return {
              id: x.subrecipeId,
              recipeName: x.recipeName,
              servings: x.recipeCostServings,
              measurementName : x.measurementName,
              totalCost: x.totalCost,
            };
          });
        }
      })
      .catch((error) => {
        this.$snotify.error(getErrorMessage(error, this.translations));
      });
  }

  getIngredientCostsForVendor(vendorId: number) {
    return this.allIngredientCosts.filter((x) => x.vendorId == vendorId);
  }

  // Table headers
  get tableHeaders() {
    return [
      {
        name: this.translations.get("ingr-cost-table-quantity"),
        key: "Quantity",
        searchable: false,
        searchString: "",
        sortable: true,
      },
      {
        name: this.translations.get("ingr-cost-table-measurement"),
        key: "Measurement",
        searchable: false,
        searchString: "",
        sortable: true,
      },
      {
        name: this.translations.get("rec-cost-table-ingr"),
        key: "Ingredient",
        searchable: true,
        searchString: "",
        sortable: true,
      },
      {
        name: this.translations.get("ingr-cost-table-vendor"),
        key: "Vendor",
        searchable: false,
        searchString: "",
        sortable: true,
      },
      {
        name: this.translations.get("rec-cost-table-search-ingr"),
        key: "SearchIngredient",
        searchable: false,
        searchString: "",
        sortable: true,
      },
      {
        name: this.translations.get("ingr-cost-table-cost"),
        key: "Cost",
        searchable: false,
        searchString: "",
        sortable: true,
      },
    ];
  }

  totalRecipeCost() {
    let total = 0;
    for (let i = 0; i < this.recipeIngredientCosts.length; i++) {
      total += this.calculateCostForRecipeIngredientCost(
        this.recipeIngredientCosts[i].quantity,
        this.recipeIngredientCosts[i].measurement.weightInGrams,
        this.recipeIngredientCosts[i].costPerGram
      );
    }
    for (let i = 0; i < this.subRecipeCosts.length; i++) {
      total += this.subRecipeCosts[i].totalCost;
    }
    return (Math.round(total * 100) / 100).toFixed(2);
  }

  get costPerYield() {
    let total = parseFloat(this.totalRecipeCost());
    let totalPerYield = total / this.recipe.servings;
    return totalPerYield.toFixed(2);
  }

  get translations() {
    return this.localizationState.translations;
  }

  created() {
    this.$store
      .dispatch(TRANSLATIONS_FETCH, {
        category: "pages",
        collections: [
          "common",
          "ingredients",
          "ingredient cost",
          "recipe costing",
        ],
      })
      .then(() => {
        document.title =
          this.translations.get("ingr-cost-title") +
          " " +
          this.translations.get("meta_title_postfix");
      })
      .catch((error) => {
        if (error.response) {
          this.$snotify.error(
            error.response.data.errorMessages[0].userVisibleMessage
          );
        }
        else
          this.$snotify.error(this.translations.get("toastr_network_error"));
      });

    this.loadAllIngredientCosts();
    this.loadIngredientCostVendors();
    this.getRecipeDetails();

    MeasurementRepository.listMeasurementsForCategory(MeasurementCategory.Mass)
      .then((response) => {
        let measurements = response.data.result.map((x: any) => {
          return {
            id: x.id,
            name: x.name,
            weightInGrams: x.conversionCoeficient,
          };
        });
        this.massMeasurements = measurements;
      })
      .catch((error) => {
        this.$snotify.error(getErrorMessage(error, this.translations));
      });
  }
}
export default RecipeCostComponent;
